import { render, staticRenderFns } from "./MonitorsParagraphs.vue?vue&type=template&id=0d7587d6&"
import script from "./MonitorsParagraphs.vue?vue&type=script&lang=js&"
export * from "./MonitorsParagraphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports